// extracted by mini-css-extract-plugin
export default {"productCarousel":"R0-z"};